import snThemeService from '../../services/snThemeService'

export default {
  name: 'SnThemeMixin',

  data () {
    return {
      sn_themeMixin_hasColors: false,
      store: (this.$store || {})
    }
  },

  created () {
    let code = null
    if (this.store) {
      if (this.store.activationCode) {
        code = this.store.activationCode
      } else if (this.store.servicerEmail) {
        code = this.store.servicerEmail
      }
    }
    snThemeService.get(code)
      .then((response) => {
        this.sn_themeMixin_setVuetifyColorsFromResponseData(response)
        this.sn_themeMixin_hasColors = true
      }).catch(e => {
        this.sn_themeMixin_hasColors = true
        this.$sentry.captureEvent({
          message: 'Error fetching custom ui theme',
          extra: {
            store: this.store,
            sac: this.store ? this.store.activationCode : undefined,
            error: e.message
          }
        })
      })
  },

  methods: {
    sn_themeMixin_validHexCode (hexCode) {
      return /^#[0-9A-F]{6}$/i.test(hexCode)
    },
    sn_themeMixin_setVuetifyColorsFromResponseData (response) {
      if (response && response.data && (response.data.primary !== '') && this.sn_themeMixin_validHexCode(response.data.primary)) {
        this.$vuetify.theme.primary = response.data.primary
      } else {
        // This is the SimpleNexus primary color (dark blue) if no color is returned
        this.$vuetify.theme.primary = '#003353'
      }

      if (response && response.data && (response.data.secondary !== '') && this.sn_themeMixin_validHexCode(response.data.secondary)) {
        this.$vuetify.theme.secondary = response.data.secondary
      } else {
        // This is the SimpleNexus secondary color (light blue) if no color is returned
        this.$vuetify.theme.secondary = '#4F7588'
      }

      if (response && response.data && (response.data.accent !== '') && this.sn_themeMixin_validHexCode(response.data.accent)) {
        this.$vuetify.theme.accent = response.data.accent
      } else if (response && response.data && (response.data.primary !== '') && this.sn_themeMixin_validHexCode(response.data.primary)) {
        this.$vuetify.theme.accent = response.data.primary
      } else {
        // This is the SimpleNexus accent color (dark blue) if no accent color is returned
        this.$vuetify.theme.accent = '#003353'
      }

      this.customColorsRetrieved = true
    }
  }
}
